import React, { ChangeEventHandler, MouseEventHandler } from 'react';

import { RadioOrSelectOption } from '../../../../../types/common.types';
import { HashTag, Member, PostWithHierarchy } from '../../../../../types/entity.types';

import TribeFeedWrapper from '../feed/wrapper/TribeFeedWrapper';
import TribeInfo from '../info/TribeInfo';

import TribePostContainer from '../../../../../containers/programme/tribe/tribe-post/TribePost.container';

import { ReactComponent as ArrowIcon } from '../../../../../resources/icons/arrow-single.svg';

import './tribe-post-hierarchy.scss';

type Props = {
  postWithHierarchy: PostWithHierarchy;
  members: Member[];
  status: string;
  onBackClick: MouseEventHandler<HTMLButtonElement>;
  filterValue: string;
  onFilterValueChange: ChangeEventHandler<HTMLInputElement>;
  searchType?: RadioOrSelectOption;
  onSearchTypeChange: (option: RadioOrSelectOption) => void;
  onComposeClick: MouseEventHandler<HTMLButtonElement>;
  onSearchClick: MouseEventHandler<HTMLButtonElement>;
  profilePicture?: string;
  pendingApprovals: number;
  hashtags?: HashTag[];
  refreshPost?: (postExternalReference: string) => void;
};

const TribePostHierarchy = ({
  postWithHierarchy,
  members,
  status,
  onBackClick,
  filterValue,
  onFilterValueChange,
  searchType,
  onSearchTypeChange,
  onComposeClick,
  onSearchClick,
  profilePicture,
  pendingApprovals,
  hashtags,
  refreshPost
}: Props) => (
  <div className="tribe-post-hierarchy" data-testid="tribe-post-hierarchy">
    <div className="tribe__header">
      <ArrowIcon className="tribe__header__arrow-icon" onClick={onBackClick} data-testid="arrow-icon" />
      <h1>Tribe Feed</h1>
    </div>
    <div className="tribe-post-hierarchy__content">
      <TribeFeedWrapper
        status={status}
        profilePicture={profilePicture}
        filterValue={filterValue}
        onFilterValueChange={onFilterValueChange}
        searchType={searchType}
        onSearchTypeChange={onSearchTypeChange}
        onComposeClick={onComposeClick}
        onSearchClick={onSearchClick}
      >
        <div className="tribe-post-hierarchy__post">
          {postWithHierarchy && (
            <TribePostContainer
              status={status}
              post={postWithHierarchy}
              hashtags={hashtags}
              refreshPost={refreshPost}
              searchType={searchType}
              hierarchy
            />
          )}
        </div>
      </TribeFeedWrapper>
      <TribeInfo members={members} status={status} pendingApprovals={pendingApprovals} />
    </div>
  </div>
);

export default TribePostHierarchy;
